import { create } from "../../../common/utils/zustand_state_manager";
import { IComercialRepository } from "../../../features/comercial/domain/repositories/comercial_repositories";
import { useComercialServices } from "./use_services";
import { ComercialRepository } from "../../../features/comercial/data/repositories/comercial_repositories";

/**
 * useComercialRepositories
 */

type State = {
  comercialRepository: IComercialRepository,
};

export const useComercialRepositories = create<State>((set, get) => {
  const { comercialService } = useComercialServices.getState();
  return ({
    comercialRepository: new ComercialRepository(comercialService),
  });

});